// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moving-menu {
    display: flex;
    justify-content: center;
    gap: 22px;
    font-size: 14px;
    font-weight: bold;
    color: #000;
    cursor: pointer;
    position: relative;
    margin-top: 20px;
  }
  
  .menu-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .ml1 {
    position: relative;
    display: inline-block;
    text-transform: uppercase;
  }
  
  .letter {
    display: inline-block;
    opacity: 0;
    transform-origin: center;
  }
  
  /* Animated Underlines */
  .menu-item-line {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: teal;
    opacity: 0;
    transform-origin: center;
    transform: scaleX(0);
  }
  
  .top {
    top: -5px;
  }
  
  .bottom {
    bottom: -5px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/MenuBar/MovingMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,wBAAwB;EAC1B;;EAEA,wBAAwB;EACxB;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd","sourcesContent":[".moving-menu {\n    display: flex;\n    justify-content: center;\n    gap: 22px;\n    font-size: 14px;\n    font-weight: bold;\n    color: #000;\n    cursor: pointer;\n    position: relative;\n    margin-top: 20px;\n  }\n  \n  .menu-item {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .ml1 {\n    position: relative;\n    display: inline-block;\n    text-transform: uppercase;\n  }\n  \n  .letter {\n    display: inline-block;\n    opacity: 0;\n    transform-origin: center;\n  }\n  \n  /* Animated Underlines */\n  .menu-item-line {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    background: teal;\n    opacity: 0;\n    transform-origin: center;\n    transform: scaleX(0);\n  }\n  \n  .top {\n    top: -5px;\n  }\n  \n  .bottom {\n    bottom: -5px;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
